module.exports = __webpack_public_path__ + "img/location-off-gray.d7fbfd1b.svg";